import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Navbar from "../Navbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { v4 as uuidv4 } from "uuid";
import { UrlApi } from "../../services/apirest";
import { logEventos } from "../../services/services";
import DialogCancelarViaje from "./DialogCancelarViaje";
import DialogEditarVehiculo from "./DialogEditarVehiculo";
import DialogCambiarDestino from "./DialogCambiarDestino";
import DrawerVehiculos from "./DrawerVehiculos";

const empresas = [
  { id: 1, nombre: "HIPERGAS" },
  { id: 4, nombre: "NATURALGAS" },
];

const tipos = [
  { id: 1, nombre: "butano" },
  { id: 2, nombre: "propano" },
  { id: 3, nombre: "propelente" },
  { id: 4, nombre: "bso" },
];

const COLORES = {
  fecha: { fondo: "#E3F2FD", borde: "#1976D2", encabezado: "#BBDEFB" },
  formulario: { fondo: "#E8F5E9", borde: "#2E7D32", encabezado: "#C8E6C9" },
  proveedores: { fondo: "#FFF8E1", borde: "#F9A825", encabezado: "#FFECB3" },
  solicitudes: { fondo: "#F3E5F5", borde: "#7B1FA2", encabezado: "#E1BEE7" },
  viajes: { fondo: "#E0F2F1", borde: "#00796B", encabezado: "#B2DFDB" },
};

const panelSx = (color) => ({
  border: "1px solid",
  borderColor: "divider",
  borderTop: `3px solid ${color.borde}`,
  borderRadius: 1,
  bgcolor: color.fondo,
  px: 1,
  py: 0.75,
});

const headerCellSx = (color) => ({
  py: 0.25,
  px: 1,
  fontSize: 11,
  fontWeight: 700,
  bgcolor: color.encabezado,
  whiteSpace: "nowrap",
});

const bodyCellSx = {
  py: 0.25,
  px: 1,
  fontSize: 12,
};

const camposCompactosSx = {
  "& .MuiOutlinedInput-root": { bgcolor: "white" },
  "& .MuiInputBase-root": { fontSize: 13 },
  "& .MuiInputBase-input": { fontSize: 13 },
  "& .MuiOutlinedInput-input": {
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  "& .MuiSelect-select.MuiSelect-outlined": {
    paddingTop: "5px",
    paddingBottom: "5px",
    minHeight: "unset",
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
    paddingTop: "2px",
    paddingBottom: "2px",
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input": {
    paddingTop: "3px",
    paddingBottom: "3px",
  },
  "& .MuiInputLabel-root": { fontSize: 13 },
  "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
    transform: "translate(14px, 6px) scale(1)",
  },
};

function TituloPanel({ children, aclaracion }) {
  return (
    <Typography
      sx={{ mb: 0.75, fontSize: 12, fontWeight: 700, lineHeight: 1.2 }}
    >
      {children}
      {aclaracion ? (
        <Box
          component="span"
          sx={{ ml: 0.5, fontWeight: 400, color: "text.secondary" }}
        >
          ({aclaracion})
        </Box>
      ) : null}
    </Typography>
  );
}

function FilaEstado({ colSpan, estado, textoVacio }) {
  let texto = textoVacio;
  let color = "text.secondary";

  if (estado === undefined) {
    texto = "Cargando...";
  } else if (estado === null) {
    texto = "No se pudo cargar. Recargá la pantalla o avisá a Sistemas.";
    color = "error.main";
  }

  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center" sx={{ ...bodyCellSx, color }}>
        {texto}
      </TableCell>
    </TableRow>
  );
}

function CeldaSaldo({ disponible, cargado, sx }) {
  const hayDatos =
    (disponible !== null && disponible !== undefined) ||
    (cargado !== null && cargado !== undefined);

  if (!hayDatos) {
    return (
      <TableCell align="center" sx={{ ...bodyCellSx, ...sx }}>
        -
      </TableCell>
    );
  }

  const saldo = Number(disponible) || 0;

  return (
    <TableCell
      align="center"
      sx={{
        ...bodyCellSx,
        whiteSpace: "nowrap",
        color: saldo < 0 ? "error.main" : "inherit",
        fontWeight: saldo < 0 ? 700 : 400,
        ...sx,
      }}
    >
      {saldo} / {Number(cargado) || 0}
    </TableCell>
  );
}

function Viajes_abastecimiento() {
  const [openSnack, setOpenSnack] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [datosViaje, setDatosViaje] = useState({
    tipo_viaje: "",
    empresa: null,
  });
  const [uuid, setUuid] = useState(uuidv4());
  const [datosRow, setDatosRow] = useState();
  const [cancelar, setCancelar] = useState(false);
  const [editar, setEditar] = useState(false);
  const [cambiarDestino, setCambiarDestino] = useState(false);
  const [destinos, setDestinos] = useState();
  const [destinoSeleccionado, setDestinoSeleccionado] = useState({});
  const [transportistas, setTransportistas] = useState();
  const [transportistaSeleccionado, setTransportistaSeleccionado] = useState(
    {}
  );
  const [bocas, setBocas] = useState();
  const [bocaSeleccionada, setBocaSeleccionada] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dataDrawer, setDataDrawer] = useState();
  const [viajes, setViajes] = useState();
  const [solicitudes, setSolicitudes] = useState();
  const [solicitudesProvee, setSolicitudesProvee] = useState();
  const [alerta, setAlerta] = useState(false);
  const [mensajeAlerta, setMensajeAlerta] = useState("");
  const [confirmacion, setConfirmacion] = useState(null);
  const [habilitado, setHabilitado] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const guardandoRef = useRef(false);
  const solicitudVehiculosRef = useRef(0);

  const mostrarError = (texto) => {
    setMensajeAlerta(texto);
    setAlerta(true);
  };

  // Las rutas viejas pueden responder 200 con un error, por eso se valida que sea una lista.
  const cargarLista = (url, setter, descripcion, valorError = null) =>
    fetch(url)
      .then(async (res) => {
        const data = await res.json().catch(() => null);

        if (!res.ok || !Array.isArray(data)) {
          throw new Error("Respuesta inválida al cargar " + descripcion);
        }

        setter(data);
      })
      .catch((err) => {
        console.error(err);
        setter(valorError);
        mostrarError("No se pudo cargar " + descripcion + ".");
      });

  useEffect(() => {
    logEventos(
      "Acceso al menú viajes",
      "Viajes",
      "Cargar nuevos viajes",
      localStorage.getItem("user")
    );
  }, []);

  const handleClickCancelar = (row) => {
    setDatosRow(row);
    setCancelar(true);
  };
  const handleCloseCancelar = () => {
    obtenerSolicitudesProvee();
    obtenerSolicitudes();
    obtenerViajes();
    obtenerVehiculos();
    setCancelar(false);
  };

  const handleClickEditar = (row) => {
    setDatosRow(row);
    setEditar(true);
  };
  const handleCloseEditar = () => {
    obtenerSolicitudesProvee();
    obtenerSolicitudes();
    obtenerViajes();
    obtenerVehiculos();
    setEditar(false);
  };

  const handleClickCambiarDestino = (row) => {
    setDatosRow(row);
    setCambiarDestino(true);
  };
  const handleCloseCambiarDestino = () => {
    obtenerSolicitudes();
    obtenerViajes();
    setCambiarDestino(false);
  };

  useEffect(() => {
    cargarLista(
      UrlApi + "/sucursales/tipoPlanta",
      setDestinos,
      "la lista de destinos"
    );
    cargarLista(
      UrlApi + "/transportistas/activos",
      setTransportistas,
      "la lista de transportistas"
    );
    cargarLista(UrlApi + "/bocas_carga", setBocas, "la lista de proveedores");
  }, []);

  //********************************************* FECHAS *********************************************//
  // Fecha única: proveedor, carga del viaje y tabla de viajes
  const [fechaBoton, setFechaBoton] = useState(() => moment().day(8));
  const fechaBotonTexto = fechaBoton.format("YYYY-MM-DD");

  // Período de solicitudes: semana de la fecha elegida y la siguiente (lunes a sábado)
  const inicioPeriodo = fechaBoton.clone().startOf("isoWeek");
  const semanaDesde = inicioPeriodo.format("YYYY-MM-DD");
  const semanaHasta = inicioPeriodo.clone().add(12, "days").format("YYYY-MM-DD");
  const periodoTexto =
    moment(semanaDesde).format("DD/MM") +
    " al " +
    moment(semanaHasta).format("DD/MM/YYYY");

  const irHaciaAtras = () => {
    setFechaBoton((prevFecha) => prevFecha.clone().subtract(1, "day"));
  };

  const irHaciaAdelante = () => {
    setFechaBoton((prevFecha) => prevFecha.clone().add(1, "day"));
  };

  const cambiarFechaCalendario = (e) => {
    if (e.target.value) {
      setFechaBoton(moment(e.target.value, "YYYY-MM-DD"));
    }
  };

  //********************************************* VEHICULOS *********************************************//
  const [vehiculos, setVehiculos] = useState([]);
  const [vehiculoSeleccionado, setVehiculoSeleccionado] = useState({});
  const [buscandoVehiculos, setBuscandoVehiculos] = useState(false);

  const obtenerVehiculos = () => {
    const idTransportista = transportistaSeleccionado.id_transportista;
    const solicitudId = ++solicitudVehiculosRef.current;

    if (!idTransportista) {
      setVehiculos([]);
      setBuscandoVehiculos(false);
      return;
    }

    setBuscandoVehiculos(true);
    fetch(
      UrlApi +
      "/vehiculos/vehict1/fechaytransportista/" +
      fechaBotonTexto +
      "/" +
      idTransportista
    )
      .then(async (res) => {
        const data = await res.json().catch(() => null);

        if (!res.ok || !Array.isArray(data)) {
          throw new Error("Respuesta inválida al cargar vehículos");
        }

        if (solicitudId === solicitudVehiculosRef.current) {
          setVehiculos(data);
        }
      })
      .catch((err) => {
        console.error(err);
        if (solicitudId === solicitudVehiculosRef.current) {
          setVehiculos([]);
          mostrarError("No se pudo cargar la lista de vehículos.");
        }
      })
      .finally(() => {
        if (solicitudId === solicitudVehiculosRef.current) {
          setBuscandoVehiculos(false);
        }
      });
  };

  // Al cambiar fecha o transportista se recarga la lista y se limpia la selección
  useEffect(() => {
    setVehiculoSeleccionado({});
    obtenerVehiculos();
  }, [transportistaSeleccionado, fechaBotonTexto]);

  const obtenerVehiculosDrawer = () => {
    if (!transportistaSeleccionado.id_transportista) {
      setDataDrawer([]);
      return;
    }

    cargarLista(
      UrlApi +
      "/vehiculos/vehict1/drawer/" +
      transportistaSeleccionado.id_transportista,
      setDataDrawer,
      "la ubicación de los vehículos",
      []
    );
  };

  useEffect(() => {
    obtenerVehiculosDrawer();
  }, [transportistaSeleccionado]);

  //********************************************* DATOS *********************************************//
  const obtenerViajes = () =>
    cargarLista(
      UrlApi + "/viajes_abastecimiento/tabla/" + fechaBotonTexto,
      setViajes,
      "la tabla de viajes"
    );

  useEffect(() => {
    obtenerViajes();
  }, [fechaBotonTexto]);

  const obtenerSolicitudes = () =>
    cargarLista(
      UrlApi +
      "/solicitudes_abastecimiento/xsemana/'" +
      semanaDesde +
      "'/'" +
      semanaHasta +
      "'",
      setSolicitudes,
      "la tabla de solicitudes"
    );

  useEffect(() => {
    obtenerSolicitudes();
  }, [semanaDesde, semanaHasta]);

  const obtenerSolicitudesProvee = () =>
    cargarLista(
      UrlApi + "/proveedores_abastecimiento/enfecha/'" + fechaBotonTexto + "'",
      setSolicitudesProvee,
      "la tabla de proveedores"
    );

  useEffect(() => {
    obtenerSolicitudesProvee();
  }, [fechaBotonTexto]);

  const obtenerDatoProveedor = (proveedorId, producto, listaProveedores, empresa) => {
    const dato = (listaProveedores || []).find(
      (item) =>
        item.proveedor === proveedorId && item.empresa_destino === empresa
    );

    if (!dato) return { disponible: null, cargado: null };

    return {
      disponible: dato[`viaje_${producto}`],
      cargado: dato[producto],
    };
  };

  const proveedoresUnicos = (solicitudesProvee || []).filter(
    (solip, index, self) =>
      index === self.findIndex((s) => s.proveedor === solip.proveedor)
  );

  const listaSolicitudes = solicitudes || [];

  //********************************************* FILTROS DEL FORMULARIO *********************************************//
  const saldosProveedores = useMemo(
    () => (Array.isArray(solicitudesProvee) ? solicitudesProvee : []),
    [solicitudesProvee]
  );

  const obtenerDisponibles = (empresa, producto, proveedor) =>
    saldosProveedores
      .filter(
        (dato) =>
          dato.empresa_destino === empresa &&
          (proveedor === undefined || dato.proveedor === proveedor)
      )
      .reduce(
        (total, dato) => total + Math.max(Number(dato[`viaje_${producto}`]) || 0, 0),
        0
      );

  const empresasDisponibles = empresas.filter((empresa) =>
    tipos.some((tipo) => obtenerDisponibles(empresa.id, tipo.nombre) > 0)
  );

  const productosDisponibles = datosViaje.empresa
    ? tipos.filter(
      (tipo) => obtenerDisponibles(datosViaje.empresa, tipo.nombre) > 0
    )
    : [];

  const proveedoresDisponibles =
    datosViaje.empresa && datosViaje.tipo_viaje
      ? (bocas || []).filter(
        (boca) =>
          obtenerDisponibles(
            datosViaje.empresa,
            datosViaje.tipo_viaje,
            boca.idbocas_carga
          ) > 0
      )
      : [];

  const etiquetaProveedor = (boca) => {
    const base = boca.proveedor + " - " + boca.nombre_boca;

    if (!datosViaje.empresa || !datosViaje.tipo_viaje) return base;

    const cantidad = obtenerDisponibles(
      datosViaje.empresa,
      datosViaje.tipo_viaje,
      boca.idbocas_carga
    );

    return `${base} (${cantidad} ${cantidad === 1 ? "disponible" : "disponibles"})`;
  };

  // Si cambia la fecha o se agota un saldo, se limpia lo que ya no sea válido.
  useEffect(() => {
    if (!Array.isArray(solicitudesProvee)) return;

    const { empresa, tipo_viaje: producto } = datosViaje;

    if (
      empresa &&
      !tipos.some((tipo) => obtenerDisponibles(empresa, tipo.nombre) > 0)
    ) {
      setDatosViaje({ tipo_viaje: "", empresa: null });
      setBocaSeleccionada({});
      return;
    }

    if (empresa && producto && obtenerDisponibles(empresa, producto) <= 0) {
      setDatosViaje({ ...datosViaje, tipo_viaje: "" });
      setBocaSeleccionada({});
      return;
    }

    if (
      empresa &&
      producto &&
      bocaSeleccionada.idbocas_carga &&
      obtenerDisponibles(empresa, producto, bocaSeleccionada.idbocas_carga) <= 0
    ) {
      setBocaSeleccionada({});
    }
  }, [solicitudesProvee]);

  const cambiarEmpresa = (e) => {
    setDatosViaje({ tipo_viaje: "", empresa: e.target.value });
    setBocaSeleccionada({});
  };

  const cambiarProducto = (e) => {
    setDatosViaje({ ...datosViaje, tipo_viaje: e.target.value });
    setBocaSeleccionada({});
  };

  //********************************************* GUARDAR *********************************************//
  function limpiarCampos() {
    setDatosViaje({
      tipo_viaje: "",
      empresa: null,
    });
    setBocaSeleccionada({});
    setDestinoSeleccionado({});
    setTransportistaSeleccionado({});
    setVehiculoSeleccionado({});
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setAlerta(false);
  };

  const guardarViaje = async (confirmaciones) => {
    if (guardandoRef.current) return;

    guardandoRef.current = true;
    setGuardando(true);

    try {
      const res = await fetch(UrlApi + "/viajes_abastecimiento/registrar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fecha: fechaBotonTexto,
          tipo_viaje: datosViaje.tipo_viaje,
          proveedor: bocaSeleccionada.idbocas_carga,
          empresa: datosViaje.empresa,
          destino: destinoSeleccionado.id,
          vehiculo: vehiculoSeleccionado.id,
          confirmar_vehiculo: confirmaciones.vehiculo === true,
          confirmar_saldo: confirmaciones.saldo === true,
          usuario: localStorage.getItem("user"),
          uuid: uuid,
        }),
      });

      const data = await res.json().catch(() => null);

      if (res.status === 409 && data?.codigo === "CONFIRMACION_VEHICULO") {
        setConfirmacion({
          titulo: "Vehículo con viajes pendientes",
          mensaje: data.mensaje,
          clave: "vehiculo",
          confirmaciones,
        });
        return;
      }

      if (res.status === 409 && data?.codigo === "CONFIRMACION_SALDO_DESTINO") {
        setConfirmacion({
          titulo: "Planta sin saldo disponible",
          mensaje: data.mensaje,
          clave: "saldo",
          confirmaciones,
        });
        return;
      }

      if (!res.ok || !data?.ok) {
        mostrarError(data?.mensaje || "No se pudo guardar el viaje.");
        obtenerSolicitudesProvee();
        return;
      }

      logEventos(
        "Guardar viaje",
        "Viajes",
        "Se guardó el viaje " + data.id_viaje,
        localStorage.getItem("user")
      );

      setMensaje("El viaje se guardó correctamente.");
      setOpenSnack(true);

      if (Array.isArray(data.avisos) && data.avisos.length > 0) {
        mostrarError(data.avisos.join(" "));
      }

      limpiarCampos();
      setUuid(uuidv4());
      obtenerSolicitudesProvee();
      obtenerSolicitudes();
      obtenerViajes();
    } catch (err) {
      console.error(err);
      mostrarError("No se pudo conectar con el servidor. Intentá nuevamente.");
    } finally {
      guardandoRef.current = false;
      setGuardando(false);
    }
  };

  const intentarGuardar = (confirmaciones = {}) => {
    setConfirmacion(null);

    const esFechaPasada = moment(fechaBotonTexto).isBefore(moment(), "day");

    if (esFechaPasada && !confirmaciones.fecha) {
      setConfirmacion({
        titulo: "Fecha anterior a hoy",
        mensaje: `La fecha del viaje es ${fechaBoton.format(
          "DD/MM/YYYY"
        )}, anterior a hoy. ¿Querés registrarlo de todos modos?`,
        clave: "fecha",
        confirmaciones,
      });
      return;
    }

    guardarViaje(confirmaciones);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  useEffect(() => {
    if (
      datosViaje.tipo_viaje === "" ||
      Object.keys(bocaSeleccionada).length === 0 ||
      Object.keys(destinoSeleccionado).length === 0 ||
      Object.keys(vehiculoSeleccionado).length === 0 ||
      datosViaje.empresa === null
    ) {
      setHabilitado(true);
    } else {
      setHabilitado(false);
    }
  }, [datosViaje, bocaSeleccionada, destinoSeleccionado, vehiculoSeleccionado]);

  //********************************************* TABLA *********************************************//
  const columns = useMemo(
    () => [
      { header: "ID", accessorKey: "id_viaje", size: 60 },
      { header: "Producto", accessorKey: "tipo_viaje", size: 85 },
      {
        header: "Proveedor",
        id: "proveedor_completo",
        accessorFn: (row) => row.prov_boca + " - " + row.nombre_boca,
        size: 165,
      },
      { header: "Empresa", accessorKey: "empresa_nombre", size: 90 },
      { header: "Destino", accessorKey: "nombre_sucursal", size: 115 },
      {
        header: "Transportista",
        id: "transportista",
        accessorFn: (row) => row.nombre_transportista || "-",
        size: 165,
      },
      { header: "Vehículo", accessorKey: "patente", size: 85 },
      { header: "Acoplados", accessorKey: "patentes_acoplados", size: 170 },
    ],
    []
  );

  return (
    <>
      <Navbar />

      <Box
        sx={{
          px: 1.5,
          py: 0.75,
          display: "flex",
          flexDirection: "column",
          gap: 0.75,
          bgcolor: "grey.50",
          minHeight: "calc(100vh - 64px)",
        }}
      >
        {/* Barra superior */}
        <Box
          sx={{
            ...panelSx(COLORES.fecha),
            ...camposCompactosSx,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            columnGap: 2,
            rowGap: 0.5,
            py: 0.5,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Tooltip title="Día anterior">
              <IconButton size="small" onClick={irHaciaAtras}>
                <ArrowBackIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
            <Typography
              sx={{
                minWidth: 66,
                fontSize: 12,
                textAlign: "center",
                textTransform: "capitalize",
                fontWeight: 600,
              }}
            >
              {fechaBoton.format("dddd")}
            </Typography>
            <TextField
              type="date"
              size="small"
              value={fechaBotonTexto}
              onChange={cambiarFechaCalendario}
              sx={{ width: 135 }}
            />
            <Tooltip title="Día siguiente">
              <IconButton size="small" onClick={irHaciaAdelante}>
                <ArrowForwardIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
          </Box>

          <Typography sx={{ fontSize: 12 }}>
            Solicitudes: <b>{periodoTexto}</b>
          </Typography>

          <Box sx={{ flexGrow: 1 }} />

          <Button
            size="small"
            variant="outlined"
            sx={{ bgcolor: "white", fontSize: 11, py: 0.25 }}
            onClick={() => setDrawerOpen(true)}
          >
            Ver vehículos
          </Button>
        </Box>

        {/* Formulario */}
        <Box sx={{ ...panelSx(COLORES.formulario), ...camposCompactosSx }}>
          <TituloPanel>Cargar viaje</TituloPanel>
          <Grid container spacing={0.75} alignItems="center">
            <Grid item xs={3}>
              <FormControl fullWidth size="small" required>
                <InputLabel>Empresa</InputLabel>
                <Select
                  label="Empresa"
                  value={datosViaje.empresa || ""}
                  onChange={cambiarEmpresa}
                >
                  {empresasDisponibles.length === 0 ? (
                    <MenuItem disabled dense value="">
                      Sin disponibles para esta fecha
                    </MenuItem>
                  ) : null}
                  {empresasDisponibles.map((elemento) => (
                    <MenuItem key={elemento.id} value={elemento.id} dense>
                      {elemento.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={3}>
              <FormControl
                fullWidth
                size="small"
                required
                disabled={!datosViaje.empresa}
              >
                <InputLabel>Producto</InputLabel>
                <Select
                  label="Producto"
                  value={datosViaje.tipo_viaje || ""}
                  onChange={cambiarProducto}
                >
                  {productosDisponibles.map((elemento) => (
                    <MenuItem
                      key={elemento.id}
                      value={elemento.nombre}
                      dense
                    >
                      {elemento.nombre.toUpperCase()}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                size="small"
                disableClearable
                disabled={!datosViaje.empresa || !datosViaje.tipo_viaje}
                options={proveedoresDisponibles}
                value={
                  bocaSeleccionada.idbocas_carga ? bocaSeleccionada : null
                }
                autoHighlight
                noOptionsText="No hay proveedores con ese producto disponible"
                isOptionEqualToValue={(option, value) =>
                  option.idbocas_carga === value.idbocas_carga
                }
                getOptionLabel={etiquetaProveedor}
                renderOption={(props, option) => (
                  <li {...props} key={option.idbocas_carga}>
                    {etiquetaProveedor(option)}
                  </li>
                )}
                onChange={(event, value) => setBocaSeleccionada(value)}
                renderInput={(params) => (
                  <TextField {...params} required label="Proveedor" />
                )}
              />
            </Grid>

            <Grid item xs={3}>
              <Autocomplete
                size="small"
                disableClearable
                options={destinos || []}
                value={destinoSeleccionado.id ? destinoSeleccionado : null}
                autoHighlight
                noOptionsText="Destino inexistente"
                isOptionEqualToValue={(option, value) =>
                  option.id === value.id
                }
                getOptionLabel={(destino) => destino.id + " - " + destino.nombre}
                onChange={(event, value) => setDestinoSeleccionado(value)}
                renderInput={(params) => (
                  <TextField {...params} required label="Destino" />
                )}
              />
            </Grid>

            <Grid item xs={3}>
              <Autocomplete
                size="small"
                disableClearable
                options={transportistas || []}
                value={
                  transportistaSeleccionado.id_transportista
                    ? transportistaSeleccionado
                    : null
                }
                autoHighlight
                noOptionsText="Transportista inexistente"
                isOptionEqualToValue={(option, value) =>
                  option.id_transportista === value.id_transportista
                }
                getOptionLabel={(transportista) =>
                  transportista.id_transportista +
                  " - " +
                  transportista.nombre
                }
                onChange={(event, value) => {
                  setTransportistaSeleccionado(value);
                  setVehiculoSeleccionado({});
                }}
                renderInput={(params) => (
                  <TextField {...params} required label="Transportista" />
                )}
              />
            </Grid>

            <Grid item xs={4}>
              <Autocomplete
                size="small"
                disableClearable
                options={vehiculos}
                value={vehiculoSeleccionado.id ? vehiculoSeleccionado : null}
                loading={buscandoVehiculos}
                disabled={buscandoVehiculos}
                autoHighlight
                noOptionsText={
                  transportistaSeleccionado.id_transportista
                    ? "No hay vehículos disponibles"
                    : "Elegí un transportista"
                }
                isOptionEqualToValue={(option, value) =>
                  option.id === value.id
                }
                getOptionLabel={(vehiculo) =>
                  vehiculo.patente +
                  (vehiculo.patentes_acoplados
                    ? " (" + vehiculo.patentes_acoplados + ")"
                    : "")
                }
                onChange={(event, value) => setVehiculoSeleccionado(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label={buscandoVehiculos ? "Buscando..." : "Vehículo"}
                  />
                )}
              />
            </Grid>

            <Grid item xs={2}>
              <Button
                fullWidth
                size="small"
                variant="contained"
                color="success"
                sx={{ fontSize: 12 }}
                onClick={() => intentarGuardar()}
                disabled={habilitado || guardando}
              >
                {guardando ? "Guardando..." : "Guardar"}
              </Button>
            </Grid>
          </Grid>
        </Box>

        {/* Saldos */}
        <Grid container spacing={0.75}>
          <Grid item xs={7}>
            <Box sx={panelSx(COLORES.proveedores)}>
              <TituloPanel aclaracion="disponibles / cargados">
                Proveedores del día
              </TituloPanel>
              <TableContainer sx={{ maxHeight: 130, bgcolor: "white" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={headerCellSx(COLORES.proveedores)}
                      >
                        Proveedor
                      </TableCell>
                      <TableCell
                        colSpan={2}
                        align="center"
                        sx={{
                          ...headerCellSx(COLORES.proveedores),
                          borderLeft: "1px solid",
                          borderColor: "divider",
                        }}
                      >
                        NaturalGas
                      </TableCell>
                      <TableCell
                        colSpan={4}
                        align="center"
                        sx={{
                          ...headerCellSx(COLORES.proveedores),
                          borderLeft: "1px solid",
                          borderColor: "divider",
                        }}
                      >
                        HiperGas
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      {["B", "P", "B", "P", "BSO", "PPTE"].map(
                        (titulo, index) => (
                          <TableCell
                            key={titulo + index}
                            align="center"
                            sx={{
                              ...headerCellSx(COLORES.proveedores),
                              top: 22,
                              borderLeft:
                                index === 0 || index === 2
                                  ? "1px solid"
                                  : undefined,
                              borderLeftColor: "divider",
                            }}
                          >
                            {titulo}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {proveedoresUnicos.length === 0 ? (
                      <FilaEstado
                        colSpan={7}
                        estado={solicitudesProvee}
                        textoVacio="Sin viajes cargados para esta fecha"
                      />
                    ) : (
                      proveedoresUnicos.map((solip) => (
                        <TableRow key={solip.proveedor} hover>
                          <TableCell sx={bodyCellSx}>
                            {solip.prove} - {solip.nombre_boca}
                          </TableCell>
                          {[
                            ["butano", 4],
                            ["propano", 4],
                            ["butano", 1],
                            ["propano", 1],
                            ["bso", 1],
                            ["propelente", 1],
                          ].map(([producto, empresa], index) => {
                            const dato = obtenerDatoProveedor(
                              solip.proveedor,
                              producto,
                              solicitudesProvee,
                              empresa
                            );

                            return (
                              <CeldaSaldo
                                key={producto + empresa}
                                disponible={dato.disponible}
                                cargado={dato.cargado}
                                sx={
                                  index === 0 || index === 2
                                    ? {
                                      borderLeft: "1px solid",
                                      borderLeftColor: "divider",
                                    }
                                    : undefined
                                }
                              />
                            );
                          })}
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>

          <Grid item xs={5}>
            <Box sx={panelSx(COLORES.solicitudes)}>
              <TituloPanel aclaracion="disponibles / pedidos">
                Solicitudes, 2 semanas
              </TituloPanel>
              <TableContainer sx={{ maxHeight: 130, bgcolor: "white" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={headerCellSx(COLORES.solicitudes)}>
                        Sucursal
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={headerCellSx(COLORES.solicitudes)}
                      >
                        B
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={headerCellSx(COLORES.solicitudes)}
                      >
                        P
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {listaSolicitudes.length === 0 ? (
                      <FilaEstado
                        colSpan={3}
                        estado={solicitudes}
                        textoVacio="Sin solicitudes en el período"
                      />
                    ) : (
                      listaSolicitudes.map((soli) => (
                        <TableRow key={soli.id_sucursal} hover>
                          <TableCell sx={bodyCellSx}>{soli.nombre}</TableCell>
                          <CeldaSaldo
                            disponible={soli.total_butano}
                            cargado={soli.pedido_butano}
                          />
                          <CeldaSaldo
                            disponible={soli.total_propano}
                            cargado={soli.pedido_propano}
                          />
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>

        {/* Viajes */}
        {viajes === null ? (
          <Alert severity="error">
            No se pudo cargar la tabla de viajes. Recargá la pantalla o avisá a
            Sistemas.
          </Alert>
        ) : null}

        {Array.isArray(viajes) ? (
          <MaterialReactTable
            columns={columns}
            data={viajes}
            localization={MRT_Localization_ES}
            layoutMode="grid"
            enableColumnActions={false}
            enableColumnFilters={false}
            enableHiding={false}
            enableDensityToggle={false}
            enableFullScreenToggle={false}
            enableStickyHeader
            enableEditing
            positionActionsColumn="last"
            displayColumnDefOptions={{
              "mrt-row-actions": {
                header: "Acciones",
                size: 110,
              },
            }}
            initialState={{
              density: "compact",
              showGlobalFilter: true,
              pagination: { pageIndex: 0, pageSize: 10 },
            }}
            muiSearchTextFieldProps={{
              placeholder: "Buscar...",
              variant: "outlined",
              size: "small",
              sx: {
                width: "12rem",
                minWidth: "12rem",
                bgcolor: "white",
                "& .MuiInputBase-input": {
                  fontSize: 12,
                  paddingTop: "4px",
                  paddingBottom: "4px",
                },
                "& .MuiSvgIcon-root": { fontSize: 16 },
              },
            }}
            muiTablePaperProps={{
              elevation: 0,
              sx: {
                border: "1px solid",
                borderColor: "divider",
                borderTop: `3px solid ${COLORES.viajes.borde}`,
              },
            }}
            muiTopToolbarProps={{
              sx: {
                bgcolor: COLORES.viajes.fondo,
                minHeight: "2.25rem",
                "& > .MuiBox-root": { py: 0.25 },
              },
            }}
            muiBottomToolbarProps={{
              sx: {
                bgcolor: COLORES.viajes.fondo,
                minHeight: "2.25rem",
                "& .MuiTablePagination-toolbar": {
                  minHeight: "2.25rem",
                },
                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select":
                {
                  fontSize: 12,
                },
              },
            }}
            muiTableContainerProps={{
              sx: { maxHeight: "calc(100vh - 415px)", minHeight: 140 },
            }}
            muiTableHeadCellProps={{
              sx: {
                fontSize: 11,
                fontWeight: 700,
                py: 0.5,
                bgcolor: COLORES.viajes.encabezado,
              },
            }}
            muiTableBodyCellProps={{
              sx: { fontSize: 12, py: 0.25 },
            }}
            renderTopToolbarCustomActions={() => (
              <Typography sx={{ fontSize: 12, fontWeight: 700, px: 0.5 }}>
                Viajes del día
              </Typography>
            )}
            renderDetailPanel={({ row }) => (
              <Typography sx={{ px: 1, fontSize: 12 }}>
                <b>Llegada:</b> {row.original.fecha_llegada || "Sin registrar"}
              </Typography>
            )}
            renderRowActions={({ row }) => (
              <Box sx={{ display: "flex", flexWrap: "nowrap" }}>
                <Tooltip arrow title="Editar vehículo">
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => handleClickEditar(row.original)}
                  >
                    <EditIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow title="Cambiar destino">
                  <IconButton
                    size="small"
                    color="warning"
                    onClick={() => handleClickCambiarDestino(row.original)}
                  >
                    <AltRouteIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow title="Cancelar viaje">
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => handleClickCancelar(row.original)}
                  >
                    <DeleteIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
          />
        ) : null}
      </Box>

      <Snackbar
        open={openSnack}
        autoHideDuration={2500}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSnack} severity="success" variant="filled">
          {mensaje}
        </Alert>
      </Snackbar>

      <Snackbar
        open={alerta}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity="warning" variant="filled">
          {mensajeAlerta}
        </Alert>
      </Snackbar>

      <Dialog
        open={Boolean(confirmacion)}
        onClose={() => setConfirmacion(null)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{confirmacion?.titulo}</DialogTitle>
        <DialogContent>
          <Alert severity="warning">{confirmacion?.mensaje}</Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmacion(null)}>Volver</Button>
          <Button
            variant="contained"
            color="warning"
            disabled={guardando}
            onClick={() =>
              intentarGuardar({
                ...confirmacion.confirmaciones,
                [confirmacion.clave]: true,
              })
            }
          >
            Continuar
          </Button>
        </DialogActions>
      </Dialog>

      {cancelar ? (
        <DialogCancelarViaje
          cancelar={cancelar}
          datosRow={datosRow}
          onClose={handleCloseCancelar}
        />
      ) : null}
      {editar ? (
        <DialogEditarVehiculo
          editar={editar}
          datosRow={datosRow}
          transportistas={transportistas}
          onClose={handleCloseEditar}
        />
      ) : null}
      {cambiarDestino ? (
        <DialogCambiarDestino
          abrir={cambiarDestino}
          datosRow={datosRow}
          destinos={destinos}
          onClose={handleCloseCambiarDestino}
        />
      ) : null}
      {drawerOpen ? (
        <DrawerVehiculos
          isOpen={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          dataDrawer={dataDrawer}
        />
      ) : null}
    </>
  );
}

export default Viajes_abastecimiento;